// Version string for the authenticated UI only — the login page is public and
// must stay metadata-free (no-public-metadata policy, 2026-08-05). Prod shows
// the clean release number; non-prod builds add the short SHA + environment
// because between releases the trunk runs unreleased code that still carries
// the last version number. All values are baked at build time by the deploy
// workflows; local dev usually has none and the caption simply hides.
import { APP_VERSION, GIT_SHA, ENV_NAME } from "./env";
import { IS_PROD } from "./environment";

const version = APP_VERSION;
const sha = (GIT_SHA || "").slice(0, 7);

const appVersion = (() => {
  if (!version) return "";
  if (IS_PROD) return `v${version}`;
  return [`v${version}`, sha, ENV_NAME].filter(Boolean).join(" · ");
})();

export default appVersion;
